import { get } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import { IntlProvider } from 'react-intl'

import { useRequest } from '../hooks/request'
import { confirmChangeEmail } from '../requests/changeEmail'
import { VARIANT_SECONDARY } from '../constants/variants'

import { CenterStuff } from './common/CenterStuff'
import { H3 } from './common/Typography'
import { Loader } from './icons/Loader'
import { Button } from './common/Button'
import { Margin } from './common/Margin'
import { useParams } from 'react-router-dom'

export const ChangeEmail = () => {

  const params = useParams();

  const confirmChangeEmailRequest = useRequest({
    request: () => confirmChangeEmail({ params: { changeToken: params.changeToken } }),
    start: true,
  })

  const messages = {
    connect: "Se connecter",
    mailChanged: "Votre adresse email a été changée. Veuillez vous connecter.",
    linkExpired: "Ce lien n'est plus valide, merci d'en demander un autre."
  }

  if (get(confirmChangeEmailRequest.state.data, 'errorCode') === 14000) {
    return (
      <IntlProvider locale="fr" messages={messages}>
        <CenterStuff>
          <div>
            <H3 tradId="linkExpired" />
            <Margin v={10} />
            <ButtonWrapper>
              <Button link to="/" tradId="connect" filled variant={VARIANT_SECONDARY} />
            </ButtonWrapper>
          </div>
        </CenterStuff>
      </IntlProvider>

    )
  }

  return (
    <IntlProvider locale="fr" messages={messages}>
      <CenterStuff>
        {confirmChangeEmailRequest.state.success
          ? (
            <div>
              <H3 tradId="mailChanged" />
              <Margin v={10} />
              <ButtonWrapper>
                <Button link to="/" tradId="connect" filled variant={VARIANT_SECONDARY} />
              </ButtonWrapper>
            </div>
          )
          : <Loader />}
      </CenterStuff>
    </IntlProvider>

  )
}

const ButtonWrapper = styled.div`
  text-align: center;
`
